import {addressStore, menuStore, userInfoStore, userTokenStore} from "@/store/store.js";
import router from "@/router/index.js";
import {menuListHooks} from "@/hooks/menu.js";
import {userLogout} from "@/api/login/login.js";
/*记录登录信息*/
export async function userLoginHooks(res, ableJump = true, ableToast = true) {
    const token = userTokenStore()
    const userInfo = userInfoStore()
    userInfo.setInfo({
        username: res.username,
        nickname: res.nickname,
        email: res.email,
        avatar: res.avatar,
        adminId: res.adminId,
        tenantId: res.tenantId,
        storeId: res.storeId,
        storeType: res.storeType,
        isBindWechat: res.isBindWechat,
        bindWechatQrCode: res.bindWechatQrCode,
        phone: res.phone,
        storeLogo: res.storeLogo ?? "",
        storeName: res.storeName ?? "",
        loginType: res.loginType,
        hasActivityRegisterExtraInfo: res.hasActivityRegisterExtraInfo
    })
    token.setToken(res.tokenInfo)
    if (ableToast) {
        ElMessage({
            type: 'success',
            message: '登录成功'
        })
    }
    await menuListHooks()
    if (ableJump) {
        let jumpLink = ""
        console.log("userInfo.info.loginType", userInfo.info.loginType)
        if (userInfo.info.loginType === 1) {
            jumpLink = await handleGetMenuFirst()
        } else if (userInfo.info.loginType === 8) {
            jumpLink = '/store/listUser'
        }
        console.log("jumpLink", jumpLink)
        await router.push(jumpLink)
    }
}
// 骑么管理员登录
export async function adminLoginHooks(res) {
    const token = userTokenStore()
    const userInfo = userInfoStore()
    userInfo.setInfo({
        username: res.username,
        nickname: res.nickname,
        email: res.email,
        avatar: res.avatar,
        adminId: res.adminId,
        tenantId: res.tenantId,
        storeId: res.storeId,
        storeType: res.storeType,
        isBindWechat: res.isBindWechat,
        bindWechatQrCode: res.bindWechatQrCode,
        phone: res.phone,
        storeLogo: res.storeLogo ?? "",
        storeName: res.storeName ?? "",
        loginType: res.loginType,
        hasActivityRegisterExtraInfo: res.hasActivityRegisterExtraInfo
    })
    token.setToken(res.tokenInfo)
    ElMessage({
        type: 'success',
        message: '登录成功'
    })
    await menuListHooks()
    const jumpLink = await handleGetMenuFirst()
    await router.push(jumpLink)
}
/*获取用户第一个跳转的链接*/
export async function handleGetMenuFirst() {
    const menuFirst = menuStore().menu.menuList[0]
    // 跳转菜单的第一个链接
    console.log("跳转的第一个链接:", menuFirst.childrenList[0].childrenList.length > 0 ? menuFirst.childrenList[0].childrenList[0].menuPermissions.link : menuFirst.childrenList[0].menuPermissions.link)
    return menuFirst.childrenList[0].childrenList.length > 0 ? menuFirst.childrenList[0].childrenList[0].menuPermissions.link : menuFirst.childrenList[0].menuPermissions.link
}

/*登出清除用户信息*/
export async function userLogoutHooks(isShowErr = true) {
    try {
        await userLogout()
    } catch (e) {
        console.log("登出异常：", e)
    }
    const token = userTokenStore()
    const userInfo = userInfoStore()
    const menu = menuStore()
    const address = addressStore()
    token.removeToken()
    userInfo.removeInfo()
    menu.removeMenu()
    address.removeAddress()
    if (isShowErr) {
        ElMessage({
            type: 'success',
            message: '登出成功'
        })
    }
    router.push("/login");
}
